<template>
<div>
	<v-form v-model="valid" ref="form">
	<h1 class="left-align">Create Message</h1>
	<v-row justify="start">
		<v-col cols="6"
        md="3">
			<v-row no-gutters>
				<v-select
					:items="items"
					label="Select Type"
					outlined
					item-text="htmlText"
          item-value="trueValue"
					v-model="messageType"
					:rules="selectTypeRules"
					required
					ref="firstFocus"
				>
				</v-select>
			</v-row>
			<v-row no-gutters v-if="messageType === 'BANNER'">
				<v-menu
						ref="menu"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
						:return-value.sync="dates"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRangeText"
                label="Date Range"
                prepend-inner-icon="event"
                readonly
								outlined
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range no-title scrollable>
							<v-spacer></v-spacer>
              <v-btn color="primary" @click="menu2 = false">Cancel</v-btn>
              <v-btn color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
						</v-date-picker>
          </v-menu>
			</v-row>
			<v-row no-gutters>
				<v-text-field
					label="Title"
					placeholder="Title"
					outlined
					v-model="messageTitle"
					:rules="messageTitleRules"
					required
				></v-text-field>
			</v-row>
			<v-row no-gutters v-if="messageType === 'EMAIL'">
				<v-checkbox
					v-model="isMessageTest"
					label="Is Test"
				></v-checkbox>
			</v-row>
		</v-col>
		<v-col >
  <div id="adminMessageTextEditor">
    <vue-editor required v-model="content" :editor-toolbar="customToolbar"></vue-editor>
  </div>
		</v-col>
	</v-row>
	<v-row>
		<v-col>
			<v-btn @click="submit" class="btn-default" text :disabled="!valid" :loading="isSubmitting" style="float: right">
    Submit
  </v-btn>
	<v-btn @click="clear" style="float: right">
    clear
  </v-btn>
		</v-col>
	</v-row>
	</v-form>
	<!-- Dialog confirmation for submitting email messages -->
	<foe-dialog
      v-model="dialogEmailConfirm"
      persistent
      max-width="600"
			class="confirm-email-message-dialog"
    >
      <v-card class="confirm-email-message-card" style="overflow-x: hidden;">
        <v-card-title class="headline">
          Confirm Email Message Submission
        </v-card-title>
        <v-card-text>
					<p class="p2 left-align">
						Are you sure you want to submit this email message? Emails will be sent to all researchers subscribed for notifications.
					</p>
				</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
						ref="firstFocusable"
            text
						class="btn-default"
            @click="dialogEmailConfirm = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
						:loading="isSubmittingDialog"
						class="btn-default"
            @click="confirm"
          >
            Submit Email
          </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
</div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { researcherApiService } from '@/services/researcherApiService.js';

export default {
	name: 'messageMaker',
	components: {
		VueEditor
	},
	data () {
		return {
			valid: true,
			messageType: 'BANNER',
			messageTitle: null,
			dates: [],
			content: '',
			customToolbar: [
				[{ header: [false, 1, 2, 3] }],
				['bold', 'italic', 'underline', 'strike'],
				[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
				['blockquote', 'code-block'],
				[{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
				[{ indent: '-1' }, { indent: '+1' }],
				[{ background: ['', '#FFFF00'] }],
				['image', 'link', 'video'],
				['clean']
			],
			items: [
				{
					htmlText: 'Banner',
					trueValue: 'BANNER'
				},
				{
					htmlText: 'Blog',
					trueValue: 'BLOG'
				},
				{
					htmlText: 'Email',
					trueValue: 'EMAIL'
				}
			],
			selectTypeRules: [(v) => !!v || 'Select Type is required'],
			messageTitleRules: [(v) => !!v || 'Message Title is required'],
			author: null,
			menu2: false,
			isMessageTest: false,
			isSubmitting: false,
			isSubmittingDialog: false,
			dialogEmailConfirm: false
		};
	},
	computed: {
		dateRangeText () {
			return this.dates.join(' ~ ')
		},
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		}
	},
	beforeMount () {
		this.author = this.userInfo.userUuid;
	},
	methods: {
		submit () {
			if (this.messageType === 'EMAIL' && this.isMessageTest === false) {
				// This will send and email blast to all researchers. Throw up a confirmation dialog.
				this.dialogEmailConfirm = true;
			} else {
				this.saveMessage();
			}
		},
		confirm () {
			this.isSubmittingDialog = true;
			const me = this;
			this.saveMessage().then(function (response) {
				me.isSubmittingDialog = false;
				me.dialogEmailConfirm = false;
			}).catch(function (error) {
				me.isSubmittingDialog = false;
				me.dialogEmailConfirm = false;
			});
		},
		saveMessage () {
			this.isSubmitting = true;
			const me = this;
			const messageObject = {
				messageType: me.messageType,
				messageTitle: me.messageTitle,
				messageBody: me.content,
				userUuid: me.author,
				dateStart: me.dates[0] || null,
				dateEnd: me.dates[1] || null
			}
			return researcherApiService.saveAdminMessage(messageObject, this.isMessageTest).then(function (response) {
				me.$store.dispatch('changeUpdateStatus', { status: 'admin-message-success' });
				me.clear();
				me.isSubmitting = false;
			}).catch(function (e) {
				console.log('e ', e)
				console.log('e.response ', e.response)
				let errorMessage = 'Your admin message failed to submit.';
				if (e.response.data.messages) {
					errorMessage = e.response.data.messages[0]
				}
				me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'admin-message-failure', message: errorMessage });
				me.isSubmitting = false;
			});
		},
		clear () {
			this.messageType = null;
			this.messageTitle = null;
			this.content = null;
			this.dates = [];
			this.isMessageTest = false;
			this.$refs.form.resetValidation();
		}
	}
};
</script>
<style>
#myDatePicker {
	/* width: 200px */
	margin: 0;
}
</style>
